<app-filter-button
  (requestReset)="handleReset()"
  [(resetConfirmed)]="resetHandled"
  [filterGroups]="filterGroup"
  (applyFilter)="onFilter()"
  [hasOtherActiveFilters]="hasAmountFilters()"
  (keydown.enter)="onFilter()">
  <div class="mb-3">
    <label
      class="filter-label"
      for="minAmount"
      >Min. Amount</label
    >
    <input
      id="minAmount"
      class="form-control"
      placeholder="R 0.00"
      [(ngModel)]="minAmount"
      currencyMask />
  </div>
  <div class="mb-3">
    <label
      class="filter-label"
      for="maxAmount"
      >Max. Amount</label
    >
    <input
      id="maxAmount"
      class="form-control"
      placeholder="R 0.00"
      [(ngModel)]="maxAmount"
      currencyMask />
  </div>
</app-filter-button>
